import { render } from "./Expense.vue?vue&type=template&id=80137b2c"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__